// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as FacebookComponent} from './Facebook.svg';

import Icon, { TIconProps } from '../Icon';

export const IconFacebook = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <FacebookComponent/>
  </Icon>
));
